<template>
	<div class="voucher">
		<a-layout id="components-layout-demo-side" style="min-height: 100vh">
			<menuBar :current="current" :openKeys="openKeys"></menuBar>
			<a-layout style="overflow: auto;">
				<topBar></topBar>
				<a-layout-content style="margin: 16px; min-width: 1192px;">
					<div style="font-size: 20px;line-height: 30px;margin-bottom: 10px;font-weight: 700;padding-left: 8px;">账户充值</div>
					<div class="contentcard" v-if="!loading">
						<strong>可用余额：￥{{sufficient_price/100000}}</strong>
					</div>
					<div class="contentcard" v-if="!loading">
						<div style="margin-bottom: 10px;">
							<strong>充值金额:</strong>
						</div>
						<div style="margin-bottom: 10px;">
							<a-radio-group @change="priceChange" v-model="voucher_price">
								<a-radio :value="100000">1000元</a-radio>
								<a-radio :value="200000">2000元</a-radio>
								<a-radio :value="300000">3000元</a-radio>
								<a-radio :value="500000">5000元</a-radio>
								<a-radio :value="1000000">10000元</a-radio>
								<a-radio :value="2000000">20000元</a-radio>
							</a-radio-group>
						</div>
						<div style="margin-bottom: 10px;">
							<strong>充值截图</strong>
						</div>
						<div style="margin-bottom: 10px;">
							<a-upload name="newbannerimg" listType="picture-card" class="avatar-uploader" :showUploadList="false" action="/costcenter/upimg"
							 :beforeUpload="beforeUpload" @change="voucher_img_get">
								<img v-if="voucher_img" :src="voucher_img" style="height: 400px;" />
								<div v-else>
									<a-icon :type="newloading ? 'loading' : 'plus'" />
									<div class="upload-text" style="margin-top: 8px;">请上传小于2MB</div>
									<div class="upload-text">JPG图片文件</div>
								</div>
							</a-upload>
						</div>
						<div style="text-align: center">
							<a-button ghost type="primary" style="width: 100px;margin-right: 20px;" @click="getbtn()">提交</a-button>
						</div>

					</div>

				</a-layout-content>
				<bottomBar></bottomBar>
			</a-layout>
		</a-layout>
		<div>
			<a-back-top />
		</div>


	</div>
</template>

<script>
	import moment from 'moment';
	export default {

		data() {
			return {
				current: ['voucher'],
				openKeys: ['costcenter'],
				loading: true,
				sufficient_price: 0,
				voucher_price: 1000,
				voucher_img: null,
				newloading: false,
				userinfo: JSON.parse(sessionStorage.getItem('userinfo')),

			}
		},
		created: function() {
			var self = this;
			var params = {
				startdate: this.moment().startOf('month').format("YYYY-MM-DD"),
				enddate: this.moment().endOf('month').format("YYYY-MM-DD"),
			};
			this.$axios.get('/costcenter/get', {
				params: params
			}).then(function(res) {
				self.sufficient_price = res.data.sufficient_price;
				self.loading = false
			});
		},
		methods: {
			moment,
			priceChange(e) {
				this.voucher_price = e.target.value
			},
			voucher_img_get(info) {
				if (info.file.status === 'uploading') {
					this.newloading = true
					return
				}
				if (info.file.status === 'done') {
					this.voucher_img = info.file.response
					this.newloading = false;
				}
			},
			beforeUpload(file) {
				const isJPG = file.type === 'image/jpeg'
				if (!isJPG) {
					this.$message.error('You can only upload JPG file!')
				}
				return isJPG
			},
			getbtn() {
				if (!this.voucher_img) {
					return this.$message.error("充值截图不能为空");
				}
				var params = {
					voucher_price: this.voucher_price,
					voucher_img: this.voucher_img,
					voucher_status: false,
					admin_user_id: this.userinfo.id
				}
				var self = this;
				this.$confirm({
					title: '提示',
					content: '是否提交',
					okText: '确认',
					cancelText: '取消',
					onOk() {
						self.$axios.post('/costcenter/get_voucher', {
							params: params
						}).then(function(res) {
							self.$notification.open({
								message: '通知',
								description: res.data,
								onClose: close,
							});
							self.$router.push({
								name: 'vouchersuccess'
							})
						})
					},
					onCancel() {},
				});
			},

		},

	};
</script>

<style>
	.voucher .contentcard {
		padding: 24px 50px;
		background-color: #fff;
		border-radius: 5px;
		margin-bottom: 20px;
		position: relative;
	}

	.voucher .click_btn {
		color: #888;
		font-size: 14px;
		color: #1890ff;
		right: 0;
		display: inline-block;
		position: absolute;
	}

	.voucher .click_btn:hover {
		cursor: pointer;
	}

	.voucher .avatar-uploader>.ant-upload {
		width: 200px;
	}

	.voucher .avatar-uploader {
		display: inline-block;
	}

	.voucher .ant-upload-select-picture-card i {
		font-size: 32px;
		color: #999;
	}

	.voucher .ant-upload-select-picture-card .upload-text {
		/* margin-top: 8px; */
		color: #666;
	}
</style>



// WEBPACK FOOTER //
// index.vue?90425674